import LocalStorageService from "../LocalStorageService";

// this is the unique key to our local storage
// don't change this unless you have a very good reason
const enhancedLocalStorageKey = "legrandAv_enhancedLocalStorageState";

function setEnhancedLocalStorage(data) {
  return LocalStorageService.setLocalStoreItem(enhancedLocalStorageKey, data);
}

function getEnhancedLocalStorage() {
  return LocalStorageService.getLocalStoreItem(enhancedLocalStorageKey);
}

function removeEnhancedLocalStorage() {
  LocalStorageService.removeLocalStoreItem(enhancedLocalStorageKey);
}

export default {
  setEnhancedLocalStorage,
  getEnhancedLocalStorage,
  removeEnhancedLocalStorage
};
